export const selectJobPostState = (state) => state.jobPostList;
export const selectJobPostFilters = (state) => state.jobPostList.filters;
